





import { Component, Vue } from 'vue-property-decorator';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { ConfigsModuleMapper } from '@/store/modules/config';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['socialNetworks']),
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'contacts']),
  },
});
@Component
export default class FooterPhoneComponent extends Mappers {
}
